import React from 'react';
const noMore = ['No more rebuilding every class and workshop from scratch.', 'No more hours searching scattered books, handouts and videos.', 'No more explaining drafting, fitting and construction with words alone.', 'No more students following steps without understanding why.', 'No more studio sessions without clear visual material.', 'No more repeating the same corrections every week.', 'No more assessing skills and garments without clear criteria.', 'No more losing time you could spend actually teaching.'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-[#520128] relative overflow-hidden" data-id="element-125" data-mp="vurukptgxbh7">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-126" data-mp="vwujf6ivwykc">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-8 leading-tight text-white uppercase" data-id="element-127" data-mp="qwzu37erch1e">
          Next Month You Can Still Be Searching for Sewing Teaching Material...
          <br data-id="element-128" data-mp="zxeg68zjq05y" />
          <span className="text-[#E3C27A]" data-id="element-129" data-mp="zxxznu4ugwm3">
            Or You Can Have a Complete Visual Training System Ready for Your Next Class.
          </span>
        </h2>
        <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white p-8 rounded-2xl border border-[#E3C27A]/60" data-id="element-130" data-mp="2h37xky5u4kz3">
          {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-131" data-mp="2m4xaykgj5aqc">
              <span className="text-[#8E2C5C] mt-0.5" aria-hidden="true" data-id="element-132" data-mp="2r2p1pb5fuqsy">
                ▸
              </span>
              <span className="text-slate-700" data-id="element-133" data-mp="2v2zfvb3dwniw">{item}</span>
            </div>)}
        </div>
        <p className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-134" data-mp="3010wzqh92crq">
          SEWING &amp; PATTERN MAKING INSTRUCTOR ATLAS doesn&apos;t replace your own experience, an accredited
          curriculum or your institution&apos;s and studio&apos;s safety rules.
        </p>
        <p className="text-xl text-white/80 mb-6" data-id="element-135" data-mp="3esjdrqhxobc5">
          It supports your teaching with a structured visual system designed to give you more:
        </p>
        <p className="text-lg md:text-2xl font-extrabold tracking-widest text-[#E3C27A]" data-id="element-136" data-mp="1jocysg5m13xl">
          CLARITY · STRUCTURE · CONSISTENCY · CONFIDENCE
        </p>
      </div>
    </section>;
}